module.exports = __webpack_public_path__ + "img/apple-touch-icon-120x120.ef406ac3.png";